<template>
  <PerfectScrollbar class="AllPwaMobile">
    <div class="AllUserDetailsShow">
      <div class="UserDetailsShow dashboard-user-overview">
        <div class="ChildUserDetailsShow dashboard-account-visual">
          <div class="ImageClassBox" size="70">
            <img src="../assets/man/userHome.jpg" alt="">
          </div>
        </div>
        <div class="ChildUserDetailsShow dashboard-balance-panel">
          <div class="dashboard-balance-heading">
            <h2 class="dashboard-balance-title">{{ $t('dashboard.availableBalance') }}</h2>
            <span v-if="hasDollarWallet && usdtRate > 0" class="dashboard-rate-pill">
              تتر {{ formatPrice(usdtRate) }} تومان
            </span>
          </div>
          <div v-if="dashboardWallets.length" class="dashboard-wallet-list">
            <div v-for="(w, idx) in dashboardWallets" :key="idx" class="dashboard-wallet-item">
                <div class="dashboard-wallet-main">
                  <span class="dashboard-wallet-name">{{ w.currency_name || w.currency_code }}</span>
                  <strong class="dashboard-wallet-amount">{{ formatCurrency(displayDashboardAvailableBalance(w)) }}</strong>
                </div>
                <small
                  v-if="usdtRate > 0 && ['USD', 'USDT'].includes((w.currency_code || '').toUpperCase())"
                  class="dashboard-wallet-conversion"
                >
                  ارزش تقریبی: {{ formatPrice(displayDashboardAvailableBalance(w) * usdtRate) }} تومان
                </small>
            </div>
          </div>
          <div v-else>
            <p class="dashboard-wallet-empty">—</p>
          </div>
          <WalletFundsBreakdown :wallets="wallets" :withdrawals="withdrawalRecords" />
        </div>
      </div>


      <div class="IconShowToUserOne">
        <router-link to="/investment">
          <div class="ChildIconShowToUserOne">
            <VsxIcon iconName="DollarSquare" :size="28" :color="color" type="linear" />

            
            <div class="TextChildIconShowToUserOne">
              <p>{{ $t('dashboard.investment') }}</p>
            </div>

          </div>
        </router-link>



        <router-link to="/contracts">
          <div class="ChildIconShowToUserOne">
            <VsxIcon iconName="FavoriteChart" :size="28" :color="color" type="linear" />

            <div class="TextChildIconShowToUserOne">
              <p>{{ $t('dashboard.contracts') }}</p>
            </div>

          </div>
        </router-link>
      </div>

      <div class="ShowIconToUse">

        <router-link to="/deposit">
          <div class="ChildShowIconToUse">
            <VsxIcon iconName="ArrowCircleDown2" :size="25" :color="color" type="linear" />
            <p>{{ $t('dashboard.deposit') }}</p>
          </div>
        </router-link>
        
        <router-link to="/withdraw">
          <div class="ChildShowIconToUse">
            <VsxIcon iconName="ArrowCircleUp2" :size="25" :color="color" type="linear" />
            <p>{{ $t('dashboard.withdraw') }}</p>
          </div>
        </router-link>
       
        <router-link to="/internal">
          <div class="ChildShowIconToUse">
            <VsxIcon iconName="RepeatCircle" :size="25" :color="color" type="linear" />
            <p>{{ $t('dashboard.internalTransfer') }}</p>
          </div>
        </router-link>
        
        <router-link to="/transaction">
          <div class="ChildShowIconToUse">
            <VsxIcon iconName="ExportCircle" :size="25" :color="color" type="linear" />
            <p>{{ $t('dashboard.transactions') }}</p>
          </div>
        </router-link>
    
      </div>
    </div>

    <div v-if="homeLoading" class="home-content-loading">
      <div class="home-skeleton home-skeleton-banner"></div>
      <div class="home-skeleton-grid">
        <div class="home-skeleton home-skeleton-card"></div>
        <div class="home-skeleton home-skeleton-card"></div>
      </div>
    </div>

    <div class="ShowChartToUser">
      <div class="AllShowIconToUserSpan">
        <div class="ShowIconToUserSpan">
          <span>$ {{formatCurrency(chartData.datasets[0].data[0])}}</span>

          <div class="IconJMoney">
            <p>{{ $t('dashboard.investmentProfit') }}</p>
            <div  style="background: #3D268E" class="CirCleShowIconToUserSpan"></div>
          </div>
        </div>

        <div class="ShowIconToUserSpan">
          <span>$ {{formatCurrency(chartData.datasets[0].data[1])}}</span>

          <div class="IconJMoney">
            <p>{{ $t('dashboard.referralProfit') }}</p>
            <div style="background: #a190d0" class="CirCleShowIconToUserSpan"></div>
          </div>
        </div>

        <div class="ShowIconToUserSpan">
          <span>$ {{formatCurrency(chartData.datasets[0].data[2])}}</span>

          <div class="IconJMoney">
            <div class="compound-profit-copy">
              <p>{{ $t('dashboard.compoundProfit') }}</p>
              <small>{{ $t('dashboard.compoundProfitMonthly') }} · {{ compoundProfitPercent }}%</small>
            </div>
            <div style="background: #4BC0C0" class="CirCleShowIconToUserSpan"></div>
          </div>
        </div>
      </div>

      <div>
        <div class="TitleStyleShow" v-show="isChartEmpty">
          <p>{{ $t('dashboard.netProfit') }}</p>
        </div>

        <div v-show="!isChartEmpty" class="chart-container">
          <canvas style="height: 100px;" ref="chartCanvas"></canvas>
        </div>
      </div>
    </div>


    
    <div class="ai-trading-demo">
      <div class="ai-trading-header">
        <div class="ai-trading-title-wrap">
          <span class="ai-trading-aura"></span>
          <div>
            <p class="ai-trading-label">هوش مصنوعی / شبیه‌سازی معاملات رباتی</p>
            <h3>هوش پورتفولیو ربات</h3>
          </div>
        </div>
        <div class="ai-trading-mode">{{ aiTrading.mode }}</div>
      </div>

      <div class="ai-trading-status-row">
        <div class="ai-status-card ai-status-card-success">
          <span class="ai-status-chip">{{ aiTrading.status }}</span>
          <strong>{{ aiTrading.robotStates[aiTrading.robotStateIndex] }}</strong>
          <small>وضعیت ربات</small>
        </div>
        <div class="ai-status-card">
          <span class="ai-status-chip">سود/زیان خالص</span>
          <strong>{{ formatSignedMoney(aiTrading.pnl) }}</strong>
          <small>{{ formatSignedPercent(aiTrading.pnlPercent) }}</small>
        </div>
        <div class="ai-status-card">
          <span class="ai-status-chip">در معرض ریسک</span>
          <strong>{{ formatCompactMoney(aiTrading.exposure) }}</strong>
          <small>{{ aiTrading.risk }}</small>
        </div>
      </div>

      <div class="ai-trading-grid">
        <section class="ai-panel ai-panel-chart">
          <div class="ai-panel-header">
            <div>
              <span class="ai-panel-kicker">نبض بازار</span>
              <h4>سبد ارزهای دیجیتال</h4>
            </div>
            <span class="ai-panel-tag">حالت شبیه‌سازی</span>
          </div>

          <div class="ai-chart-wrap">
            <svg viewBox="0 0 100 100" preserveAspectRatio="none" class="ai-chart-svg" aria-label="AI portfolio chart">
              <defs>
                <linearGradient id="aiChartFill" x1="0" x2="0" y1="0" y2="1">
                  <stop offset="0%" stop-color="#7c5cff" stop-opacity="0.38" />
                  <stop offset="100%" stop-color="#7c5cff" stop-opacity="0.02" />
                </linearGradient>
              </defs>
              <polyline :points="aiChartAreaPoints" fill="url(#aiChartFill)" stroke="none" />
              <polyline :points="aiChartPointsSvg" fill="none" stroke="#7c5cff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="ai-chart-legend">
              <span><b>BTC</b> {{ formatMarketPrice(aiTrading.marketSymbols[0]?.price || 0) }}</span>
              <span><b>ETH</b> {{ formatMarketPrice(aiTrading.marketSymbols[1]?.price || 0) }}</span>
              <span><b>SOL</b> {{ formatMarketPrice(aiTrading.marketSymbols[2]?.price || 0) }}</span>
            </div>
          </div>
        </section>

        <aside class="ai-panel ai-panel-side">
          <div class="ai-panel-header">
            <div>
              <span class="ai-panel-kicker">پورتفولیو</span>
              <h4>تخصیص دارایی</h4>
            </div>
          </div>

          <div class="ai-portfolio-highlight">
            <small>سرمایه</small>
            <strong>{{ formatCompactMoney(aiTrading.equity) }}</strong>
          </div>

          <ul class="ai-portfolio-list">
            <li>
              <span>نقد</span>
              <strong>{{ formatCompactMoney(aiTrading.cash) }}</strong>
            </li>
            <li>
              <span>پوزیشن‌های بلند</span>
              <strong>{{ formatCompactMoney(aiTrading.longs) }}</strong>
            </li>
            <li>
              <span>پوزیشن‌های کوتاه</span>
              <strong>{{ formatCompactMoney(aiTrading.shorts) }}</strong>
            </li>
            <li>
              <span>نرخ برد</span>
              <strong>{{ aiTrading.winRate }}%</strong>
            </li>
          </ul>
        </aside>
      </div>

      <div class="ai-trading-lower-grid">
        <section class="ai-panel">
          <div class="ai-panel-header">
            <div>
              <span class="ai-panel-kicker">اسکنر</span>
              <h4>بالا‌ترین اطمینان</h4>
            </div>
          </div>

          <div class="ai-scanner-list">
            <div v-for="(item, index) in aiTrading.marketSymbols" :key="index" class="ai-scanner-row">
              <div class="ai-scanner-coin">
                <span class="ai-coin-badge">{{ item.symbol.slice(0, 2) }}</span>
                <div>
                  <strong>{{ item.symbol }}</strong>
                  <small>{{ item.trend }}</small>
                </div>
              </div>
              <div class="ai-scanner-meta">
                <span>{{ formatMarketPrice(item.price) }}</span>
                <strong :class="item.change >= 0 ? 'positive' : 'negative'">{{ formatSignedPercent(item.change) }}</strong>
              </div>
            </div>
          </div>
        </section>

        <section class="ai-panel">
          <div class="ai-panel-header">
            <div>
              <span class="ai-panel-kicker">تصمیم</span>
              <h4>پیشنهاد هوش مصنوعی</h4>
            </div>
          </div>

          <div class="ai-decision-box">
            <div class="ai-decision-score">
              <span>اعتماد</span>
              <strong>{{ aiTrading.confidence }}%</strong>
            </div>
            <div class="ai-decision-label">
              {{ aiTrading.decision }}
            </div>
            <p>{{ aiTrading.decisionNote }}</p>
          </div>
        </section>
      </div>

      <div class="ai-trading-two-col">
        <section class="ai-panel">
          <div class="ai-panel-header">
            <div>
              <span class="ai-panel-kicker">پوزیشن‌ها</span>
              <h4>معاملات باز</h4>
            </div>
          </div>

          <table class="ai-table">
            <thead>
              <tr>
                <th>دارایی</th>
                <th>طرف</th>
                <th>تعداد</th>
                <th>سود/زیان</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(position, index) in aiTrading.positions" :key="index">
                <td>{{ position.symbol }}</td>
                <td :class="position.side === 'Long' ? 'positive' : 'negative'">{{ position.side }}</td>
                <td>{{ position.qty }}</td>
                <td :class="position.pnl >= 0 ? 'positive' : 'negative'">{{ formatSignedMoney(position.pnl) }}</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section class="ai-panel">
          <div class="ai-panel-header">
            <div>
              <span class="ai-panel-kicker">فعالیت</span>
              <h4>سیگنال‌های اخیر</h4>
            </div>
          </div>

          <ul class="ai-activity-feed">
            <li v-for="(event, index) in aiTrading.activity" :key="index">
              <span class="ai-feed-dot"></span>
              <div>
                <strong>{{ event.title }}</strong>
                <small>{{ event.time }}</small>
              </div>
            </li>
          </ul>
        </section>
      </div>

      <div class="ai-panel ai-panel-full">
        <div class="ai-panel-header">
          <div>
            <span class="ai-panel-kicker">تاریخچه</span>
            <h4>گزارش معاملات</h4>
          </div>
        </div>

        <table class="ai-table">
          <thead>
            <tr>
              <th>زمان</th>
              <th>جفت</th>
              <th>سیگنال</th>
              <th>نتیجه</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in aiTrading.tradeHistory" :key="index">
              <td>{{ item.time }}</td>
              <td>{{ item.pair }}</td>
              <td>{{ item.signal }}</td>
              <td :class="item.result.startsWith('+') ? 'positive' : 'negative'">{{ item.result }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="!homeLoading && (homeContent.banners.length || homeContent.cards.length)" class="home-spotlight">
      <div v-if="homeContent.banners.length" class="spotlight-banner">
        <div
          class="spotlight-banner-viewport"
          @touchstart="startBannerSwipe"
          @touchend="finishBannerSwipe"
        >
          <transition :name="bannerTransitionName" mode="out-in">
            <div
              v-if="currentBanner"
              :key="currentBannerPage"
              class="spotlight-banner-slide"
              :class="{ 'spotlight-banner-slide-clickable': bannerUrl(currentBanner) }"
              @click="openBannerLink(bannerUrl(currentBanner))"
            >
              <div class="spotlight-banner-inner">
                <div class="spotlight-banner-visual">
                  <div class="spotlight-banner-icon">
                    <VsxIcon :iconName="normalizeIconName(currentBanner.icon || 'DollarSquare')" :size="38" color="#BB86FC" type="linear" />
                  </div>
                </div>

                <div class="spotlight-banner-copy">
                  <h3>{{ currentBanner.title || 'سرمایه‌گذاری' }}</h3>
                  <p>{{ currentBanner.description || 'از مزایای VIP' }}</p>
                </div>

              </div>
            </div>
          </transition>
        </div>

        <div v-if="homeContent.banners.length > 1" class="spotlight-pagination">
          <span
            v-for="(banner, index) in homeContent.banners"
            :key="index"
            :class="['spotlight-dot', { active: index === currentBannerPage }]"
            @click="setBannerSlide(index)"
          ></span>
        </div>
      </div>


      <div class="spotlight-cards">
        <article v-for="(card, index) in currentCardPageCards" :key="index" class="spotlight-card">
          <div class="spotlight-card-badge-row">
            <span v-if="card.badge" class="spotlight-card-badge">{{ card.badge }}</span>
          </div>

          <div class="spotlight-card-icon">
            <img v-if="card.image" :src="card.image" alt="" />
            <VsxIcon v-else :iconName="normalizeIconName(card.icon || 'Coin')" :size="28" color="#BB86FC" type="linear" />
          </div>

          <h4>{{ card.title || 'پیشنهاد ویژه' }}</h4>
          <p v-if="card.subtitle" class="spotlight-card-subtitle">{{ card.subtitle }}</p>
          <p v-if="card.description" class="spotlight-card-description">{{ card.description }}</p>
          <div v-if="card.value" class="spotlight-card-value">{{ card.value }}</div>

          <div class="spotlight-card-pagination">
            <span
              v-for="(page, pageIndex) in cardPages"
              :key="pageIndex"
              :class="['spotlight-dot', { active: currentCardPage === pageIndex }]"
              @click="setCardPage(pageIndex)"
            ></span>
          </div>
        </article>
      </div>
    </div>


  </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import axios from "@/axios";
import { Chart, DoughnutController, ArcElement, Tooltip, Legend } from 'chart.js';
import WalletFundsBreakdown from './WalletFundsBreakdown.vue';

export default {
  name: 'indexUser',
  components: {
    PerfectScrollbar,
    WalletFundsBreakdown,
  },
  data() {
    return {
      color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
      chartInstance: null,
      chartData: {
        // labels: ['300', '50', '100', '200'],
        datasets: [
          {
            data: [0, 0, 0],
            backgroundColor: ['#3D268E', '#a190d0', '#4BC0C0'],
            hoverBackgroundColor: ['#2e1977', '#6f6194', '#399696']
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'left',
          },
          tooltip: {
            enabled: true,
          }
        },
      },
      deposit_wallet: 0,
      interest_wallet: 0,
      referral_wallet: 0,
      totalAmount: 0,

      userLis : [],
      usdtRate: 0,
      totalRial: 0,
      compoundProfitPercent: 0,

      investment: 0,
      depositing: 0,
      wallets: [],
      pendingWithdrawalBalances: {},
      withdrawalRecords: [],
      homeContent: {
        banner: null,
        banners: [],
        cards: []
      },
      homeLoading: false,
      homeError: null,
      currentCardPage: 0,
      currentBannerPage: 0,
      bannerTransitionName: 'banner-slide-left',
      bannerTouchStartX: null,
      spotlightTimer: null,
      aiTradingTimer: null,
      aiTrading: {
        mode: 'Paper Trading',
        status: 'AI Active',
        risk: 'Medium',
        pnl: 1245000,
        pnlPercent: 6.4,
        exposure: 3865000,
        equity: 128450000,
        cash: 3440000,
        longs: 4820000,
        shorts: 2310000,
        winRate: 68.4,
        confidence: 82,
        decision: 'Buy momentum continuation',
        decisionNote: 'Momentum remains healthy across majors while volatility stays inside the model trigger bands.',
        robotStateIndex: 0,
        robotStates: ['Scanning liquidity', 'Validating trend', 'Managing risk', 'Optimizing exits'],
        marketSymbols: [
          { symbol: 'BTC/USD', price: 68240.12, change: 2.14, trend: 'Bullish', score: 92 },
          { symbol: 'ETH/USD', price: 3524.88, change: 1.63, trend: 'Bullish', score: 88 },
          { symbol: 'SOL/USD', price: 142.41, change: -0.68, trend: 'Neutral', score: 74 },
          { symbol: 'XRP/USD', price: 0.62, change: 1.12, trend: 'Bullish', score: 81 }
        ],
        positions: [
          { symbol: 'BTC', side: 'Long', qty: 0.42, pnl: 18400 },
          { symbol: 'ETH', side: 'Long', qty: 1.8, pnl: 9650 },
          { symbol: 'SOL', side: 'Short', qty: 160, pnl: -4200 }
        ],
        activity: [
          { title: 'Trend model accepted BTC breakout', time: 'Just now' },
          { title: 'ETH funding remained neutral', time: '2 min ago' },
          { title: 'Risk guard reduced SOL sizing', time: '5 min ago' },
          { title: 'Portfolio balance rebalanced', time: '9 min ago' }
        ],
        tradeHistory: [
          { time: '09:42', pair: 'BTC/USD', signal: 'Long', result: '+$2,340' },
          { time: '09:30', pair: 'ETH/USD', signal: 'Long', result: '+$1,120' },
          { time: '09:18', pair: 'SOL/USD', signal: 'Short', result: '+$680' },
          { time: '09:05', pair: 'XRP/USD', signal: 'Long', result: '-$220' }
        ],
        chartPoints: [42, 46, 49, 58, 62, 66, 74, 70, 82]
      }
    };
  },
  computed: {
    dashboardWallets() {
      return this.wallets.filter(wallet => (wallet.currency_code || '').toUpperCase() !== 'IRR');
    },
    hasDollarWallet() {
      return this.dashboardWallets.some(wallet => ['USD', 'USDT'].includes((wallet.currency_code || '').toUpperCase()));
    },
    currentBanner() {
      return this.homeContent.banners[this.currentBannerPage] || null;
    },
    aiChartPointsSvg() {
      const values = this.aiTrading.chartPoints;
      if (!values.length) return '';
      const max = Math.max(...values);
      const min = Math.min(...values);
      const range = max - min || 1;
      return values.map((value, index) => {
        const x = (index / (values.length - 1)) * 100;
        const y = 100 - ((value - min) / range) * 70 - 15;
        return `${x},${y}`;
      }).join(' ');
    },
    aiChartAreaPoints() {
      const points = this.aiChartPointsSvg;
      if (!points) return '';
      return `${points} 100,100 0,100`;
    },
    isChartEmpty() {
      const sum = this.chartData.datasets[0].data.reduce((acc, val) => acc + parseFloat(val || 0), 0);
      return sum === 0;
    },
    cardPages() {
      const cards = Array.isArray(this.homeContent.cards) ? this.homeContent.cards.filter(Boolean) : [];
      const pages = [];

      for (let index = 0; index < cards.length; index += 2) {
        pages.push(cards.slice(index, index + 2));
      }

      return pages.length ? pages : [[]];
    },
    currentCardPageCards() {
      return this.cardPages[this.currentCardPage] || [];
    }
  },
  methods: {
    async fetchNobitexUSDTPrice() {
      const response = await axios.get('https://apiv2.nobitex.ir/market/stats?srcCurrency=usdt&dstCurrency=rls', {
        timeout: 5000
      });
      const latestRialPrice = Number(response.data?.stats?.['usdt-rls']?.latest);

      if (response.data?.status !== 'ok' || !Number.isFinite(latestRialPrice) || latestRialPrice <= 0) {
        throw new Error('Invalid USDT/IRR price response from Nobitex');
      }

      this.usdtRate = latestRialPrice / 10;
      this.calculateTotal();
    },

    async fetchUSDT1() {
      try {
        await this.fetchNobitexUSDTPrice();
      } catch (error) {
        console.error('Error fetching USDT price from Nobitex:', error);
      }
    },

    formatCurrency(amount) {
      const numericAmount = parseFloat(amount); // تبدیل به عدد
      if (isNaN(numericAmount)) {
        return '$0.00'; // اگر مقدار عددی نبود
      }
      return numericAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); // فرمت‌دهی با کاما
    },

    formatMarketPrice(value) {
      const numeric = Number(value || 0);
      if (!Number.isFinite(numeric)) return '$0.00';
      return `$${numeric.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    },

    formatCompactMoney(value) {
      const numeric = Number(value || 0);
      if (!Number.isFinite(numeric)) return '$0';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(numeric);
    },

    formatSignedPercent(value) {
      const numeric = Number(value || 0);
      if (!Number.isFinite(numeric)) return '+0.00%';
      return `${numeric >= 0 ? '+' : ''}${numeric.toFixed(2)}%`;
    },

    formatSignedMoney(value) {
      const numeric = Number(value || 0);
      if (!Number.isFinite(numeric)) return '$0';
      return `${numeric >= 0 ? '+' : '-'}${this.formatCompactMoney(Math.abs(numeric))}`;
    },

    updateTradingSimulation() {
      this.aiTrading.robotStateIndex = (this.aiTrading.robotStateIndex + 1) % this.aiTrading.robotStates.length;
      this.aiTrading.marketSymbols = this.aiTrading.marketSymbols.map((item, index) => {
        const drift = (Math.random() - 0.45) * 0.026;
        const nextPrice = item.price * (1 + drift + index * 0.0008);
        const nextChange = Number((item.change + (Math.random() - 0.48) * 1.8).toFixed(2));
        const nextTrend = nextChange >= 0 ? 'Bullish' : 'Soft';
        return {
          ...item,
          price: Number(nextPrice.toFixed(2)),
          change: nextChange,
          trend: nextTrend,
          score: Math.max(60, Math.min(98, Math.round(item.score + (Math.random() - 0.5) * 12)))
        };
      });

      this.aiTrading.chartPoints = this.aiTrading.chartPoints.map((point) => {
        const next = point + (Math.random() - 0.45) * 12;
        return Math.max(18, Math.min(94, Number(next.toFixed(1))));
      });

      const pnlDelta = (Math.random() - 0.48) * 26000;
      this.aiTrading.pnl = Math.max(0, Number((this.aiTrading.pnl + pnlDelta).toFixed(0)));
      this.aiTrading.pnlPercent = Number((this.aiTrading.pnlPercent + (Math.random() - 0.48) * 1.8).toFixed(2));
      this.aiTrading.exposure = Number((this.aiTrading.exposure + (Math.random() - 0.48) * 220000).toFixed(0));
      this.aiTrading.equity = Number((this.aiTrading.equity + (Math.random() - 0.52) * 680000).toFixed(0));
      this.aiTrading.cash = Number((this.aiTrading.cash + (Math.random() - 0.42) * 220000).toFixed(0));
      this.aiTrading.confidence = Math.max(67, Math.min(95, Math.round(this.aiTrading.confidence + (Math.random() - 0.5) * 10)));
      this.aiTrading.decision = ['Buy momentum continuation', 'Scale into quality trend', 'Wait for fresh confirmation', 'Protect downside with tighter stops'][Math.floor(Math.random() * 4)];

      const activityTitle = [
        'Trend model accepted BTC breakout',
        'ETH volatility compressed under threshold',
        'Risk guard tightened portfolio exposure',
        'AI scenario updated for alt rotation'
      ];

      this.aiTrading.activity.unshift({
        title: activityTitle[Math.floor(Math.random() * activityTitle.length)],
        time: 'Just now'
      });
      this.aiTrading.activity = this.aiTrading.activity.slice(0, 5);

      const resultValue = (Math.random() > 0.48 ? 1 : -1) * (Math.random() * 1200 + 400);
      this.aiTrading.tradeHistory.unshift({
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        pair: this.aiTrading.marketSymbols[0].symbol,
        signal: this.aiTrading.decision.includes('Buy') ? 'Long' : 'Short',
        result: `${resultValue >= 0 ? '+' : '-'}$${Math.abs(resultValue).toFixed(0)}`
      });
      this.aiTrading.tradeHistory = this.aiTrading.tradeHistory.slice(0, 5);
    },

    async fetchUSDT() {
      try {
          await this.fetchNobitexUSDTPrice();
          await this.getUserData();
        } catch (error) {
          console.error('Error fetching USDT price from Nobitex:', error);
        }
    },

    async getUserData(){
      const userData = localStorage.getItem('user');
      if (!userData) {
        console.warn('No user data found in localStorage');
        return;
      }

      try {
        this.userLis = JSON.parse(userData);
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        return;
      }

      if (!this.userLis || !this.userLis.id) {
        console.warn('Invalid user data structure');
        return;
      }

      let attempts = 0;
      const maxAttempts = 3; // کاهش تعداد تلاش‌ها
      const delay = 1000; // افزایش زمان انتظار

      while (attempts < maxAttempts) {
        try {
          const response = await axios.post('/get-user-data', {
            id: this.userLis.id
          });

          // بررسی اینکه پاسخ معتبر باشد
          if (response.data && Array.isArray(response.data)) {
            this.deposit_wallet = parseFloat(response.data[0] || 0);
            this.interest_wallet = parseFloat(response.data[1] || 0);
            this.referral_wallet = parseFloat(response.data[2] || 0);

            this.investment = parseFloat(response.data[3] || 0);
            // Keep legacy profit series and show lifetime compound payouts in the existing metric.
            const investmentProfit = parseFloat(response.data[4] || 0);
            const referralProfit = parseFloat(response.data[5] || 0);
            this.chartData.datasets[0].data[0] = investmentProfit;
            this.chartData.datasets[0].data[1] = referralProfit;
            this.chartData.datasets[0].data[2] = Math.max(0, parseFloat(response.data[9] || 0));
            this.compoundProfitPercent = Math.max(0, parseFloat(response.data[8] || 0));

            this.calculateTotal();

            // Render chart after data is loaded
            this.$nextTick(() => {
              this.renderChart();
            });

            return; // موفقیت‌آمیز بود، خارج شو
          } else {
            throw new Error('Invalid response format');
          }

        } catch (error) {
          console.error(`Attempt ${attempts + 1} failed:`, error.response?.data || error.message);

          if (attempts === maxAttempts - 1) {
            // آخرین تلاش ناموفق بود
            console.error('Failed to fetch user data after all attempts');

            // تنظیم مقادیر پیش‌فرض
            this.deposit_wallet = 0;
            this.interest_wallet = 0;
            this.referral_wallet = 0;
            this.investment = 0;
            this.compoundProfitPercent = 0;
            this.chartData.datasets[0].data = [0, 0, 0];
            this.calculateTotal();
          }
        }

        attempts++;
        if (attempts < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    },

    async fetchWalletUsers(){
      try {
        const userData = localStorage.getItem('user');
        const user = userData ? JSON.parse(userData) : null;
        if (!user || !user.id) return;

        const res = await axios.post('/get-wallet-users', { user_id: user.id });
        if (res.data && res.data.success && Array.isArray(res.data.data)) {
          this.wallets = res.data.data;
        } else if (Array.isArray(res.data)) {
          // fallback shape (if server returns plain array)
          this.wallets = res.data;
        }
      } catch (e) {
        console.error('Failed to fetch wallet users', e);
      }
    },

    async fetchPendingWithdrawals(){
      try {
        const userData = localStorage.getItem('user');
        const user = userData ? JSON.parse(userData) : null;
        if (!user?.id) return;

        const response = await axios.post('/withdraw-user', { user_id: user.id });
        const withdrawals = response.data?.[1]?.[0]?.data;
        if (!Array.isArray(withdrawals)) return;
        this.withdrawalRecords = withdrawals;

        this.pendingWithdrawalBalances = withdrawals.reduce((totals, withdrawal) => {
          // New pending requests have already been debited from wallet_users.
          // Only legacy requests without an immediate debit should be reserved here.
          if (Number(withdrawal.status) !== 2 || withdrawal.balance_deducted) return totals;
          const code = (withdrawal.currency || '').toUpperCase();
          const key = ['USD', 'USDT'].includes(code) ? 'USD' : code;
          const totalDebited = Number(withdrawal.total_debited || 0);
          totals[key] = (totals[key] || 0) + (totalDebited > 0 ? totalDebited : Number(withdrawal.amount || 0));
          return totals;
        }, {});
      } catch (error) {
        console.error('Failed to fetch pending withdrawals for dashboard', error);
      }
    },

    pendingWithdrawalFor(wallet){
      const code = (wallet.currency_code || '').toUpperCase();
      const pendingDollar = Number(this.pendingWithdrawalBalances.USD || 0);
      if (code === 'USD') {
        const usdWallet = this.wallets.find(item => (item.currency_code || '').toUpperCase() === 'USD');
        const usdAvailable = Number(usdWallet?.available_balance ?? usdWallet?.balance ?? 0);
        return Math.min(pendingDollar, Math.max(usdAvailable, 0));
      }
      if (code === 'USDT') {
        const hasUsdWallet = this.wallets.some(item => (item.currency_code || '').toUpperCase() === 'USD');
        if (!hasUsdWallet) return pendingDollar;
        const usdWallet = this.wallets.find(item => (item.currency_code || '').toUpperCase() === 'USD');
        const usdAvailable = Number(usdWallet?.available_balance ?? usdWallet?.balance ?? 0);
        return Math.max(0, pendingDollar - Math.max(usdAvailable, 0));
      }
      return Number(this.pendingWithdrawalBalances[code] || 0);
    },

    displayDashboardAvailableBalance(wallet){
      const available = Number(wallet.available_balance ?? wallet.balance ?? 0);
      return Math.max(0, available - this.pendingWithdrawalFor(wallet));
    },

    formatDashboardBalance(currencyCode, amount){
      return this.formatCurrency(amount);
    },

    async fetchHomeContent() {
      this.homeLoading = true;
      this.homeError = null;

      try {
        const response = await axios.get('/homepage/public');
        const data = response?.data?.data || {};

        this.homeContent = {
          banner: data.banner || null,
          banners: Array.isArray(data.banners) && data.banners.length
            ? data.banners.filter(Boolean)
            : (data.banner ? [data.banner] : []),
          cards: Array.isArray(data.cards) ? data.cards.filter(Boolean) : []
        };

        if (!this.homeContent.banners.length && data.hero) {
          const fallbackBanner = {
            title: data.site?.site_name || 'سرمایه‌گذاری',
            description: data.hero.description || '',
            icon: 'DollarSquare',
            url: ''
          };
          this.homeContent.banner = fallbackBanner;
          this.homeContent.banners = [fallbackBanner];
        }

        this.currentCardPage = 0;
        this.currentBannerPage = 0;
        this.startSpotlightSlider();
      } catch (error) {
        console.error('Failed to fetch homepage content', error);
        this.homeError = 'Unable to load homepage content';
        this.homeContent = { banner: null, banners: [], cards: [] };
      } finally {
        this.homeLoading = false;
      }
    },

    setBannerSlide(index) {
      const bannerCount = this.homeContent.banners.length;
      if (!bannerCount) return;
      this.bannerTransitionName = index >= this.currentBannerPage
        ? 'banner-slide-left'
        : 'banner-slide-right';
      this.currentBannerPage = (index + bannerCount) % bannerCount;
    },

    startBannerSwipe(event) {
      this.bannerTouchStartX = event.changedTouches[0]?.clientX || null;
    },

    finishBannerSwipe(event) {
      if (this.bannerTouchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX;
      const distance = endX - this.bannerTouchStartX;
      this.bannerTouchStartX = null;

      if (Math.abs(distance) < 40) return;
      this.setBannerSlide(this.currentBannerPage + (distance < 0 ? 1 : -1));
    },

    openBannerLink(rawUrl) {
      const url = typeof rawUrl === 'string' ? rawUrl.trim() : '';
      if (!url || url === '#') return;

      try {
        const target = new URL(url, window.location.origin);
        if (target.origin === window.location.origin) {
          this.$router.push(`${target.pathname}${target.search}${target.hash}`);
          return;
        }
      } catch (error) {
        console.warn('Invalid banner URL:', url);
        return;
      }

      window.location.assign(url);
    },

    bannerUrl(banner) {
      const url = banner?.url || banner?.button_url || '';
      return typeof url === 'string' && url.trim() && url.trim() !== '#' ? url.trim() : '';
    },

    setCardPage(index) {
      if (index >= 0 && index < this.cardPages.length) {
        this.currentCardPage = index;
      }
    },

    startSpotlightSlider() {
      if (this.spotlightTimer) {
        clearInterval(this.spotlightTimer);
      }

      if (this.homeContent.banners.length <= 1 && this.cardPages.length <= 1) {
        return;
      }

      this.spotlightTimer = setInterval(() => {
        if (this.homeContent.banners.length > 1) {
          this.setBannerSlide(this.currentBannerPage + 1);
        }
        if (this.cardPages.length > 1) {
          this.currentCardPage = (this.currentCardPage + 1) % this.cardPages.length;
        }
      }, 4000);
    },

    normalizeIconName(iconName) {
      const safeMap = {
        Coins: 'Coin',
        WalletMoney: 'WalletMoney',
        Wallet: 'Wallet',
        UserAdd: 'UserAdd',
      };

      const raw = typeof iconName === 'string' ? iconName.trim() : '';
      if (!raw) return 'Coin';

      if (safeMap[raw]) return safeMap[raw];

      return raw;
    },

    showAmount(amount, decimalPlaces = 0) {
      if (typeof amount !== 'number' || isNaN(amount)) {
        console.warn('Invalid amount:', amount);
        return '0.00';
      }

      if (typeof decimalPlaces !== 'number' || decimalPlaces < 0) {
        decimalPlaces = 0;
      }

      return Number(amount).toFixed(decimalPlaces);
    },

    calculateTotal() {
      this.totalAmount = parseFloat(this.deposit_wallet || 0) + parseFloat(this.interest_wallet || 0) + parseFloat(this.referral_wallet || 0);
      this.totalRial = this.totalAmount * (this.usdtRate || 0);
    },

    handleClick() {
      alert('Button clicked!');
    },
    formatPrice(value) {
      if (typeof value !== 'number' && typeof value !== 'string') {
        return '0';
      }

      let numericValue = typeof value === 'string' ? parseFloat(value) : value;

      if (isNaN(numericValue)) {
        return '0';
      }

      // برای مقادیر ریال، از ۰ رقم اعشار استفاده می‌کنیم
      let formatted = numericValue.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return formatted;
    },

    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if( savedTheme == "light"){
        this.color = '#2E1977'
      }else{
        this.color = '#BB86FC'
      }
    },

    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      // Register required components
      Chart.register(DoughnutController, ArcElement, Tooltip, Legend);

      const ctx = this.$refs.chartCanvas;
      if (!ctx) {
        console.warn('Chart canvas not found');
        return;
      }

      // اطمینان از معتبر بودن داده‌ها
      const chartData = {
        datasets: [{
          data: this.chartData.datasets[0].data.map(val => Math.max(0, parseFloat(val || 0))),
          backgroundColor: this.chartData.datasets[0].backgroundColor || ['#3D268E', '#a190d0', '#5584FF', '#4BC0C0'],
          hoverBackgroundColor: this.chartData.datasets[0].hoverBackgroundColor || ['#2e1977', '#6f6194', '#4773e5', '#399696']
        }]
      };

      // اگر همه داده‌ها صفر باشند، نمودار را نشان نده
      const sum = chartData.datasets[0].data.reduce((acc, val) => acc + val, 0);
      if (sum === 0) {
        return;
      }

      try {
        this.chartInstance = new Chart(ctx, {
          type: 'doughnut',
          data: chartData,
          options: this.chartOptions
        });
      } catch (error) {
        console.error('Error creating chart:', error);
      }
    },
  },
  mounted(){
    this.fetchUSDT()
    this.fetchWalletUsers()
    this.fetchPendingWithdrawals()
    this.fetchHomeContent()

    setInterval(() => {
      this.loadTheme()
    }, 100);

    setInterval(() => {
      this.fetchUSDT1()
    }, 30000);

    this.aiTradingTimer = setInterval(() => {
      this.updateTradingSimulation();
    }, 5000);
  },
  beforeUnmount() {
    if (this.spotlightTimer) {
      clearInterval(this.spotlightTimer);
      this.spotlightTimer = null;
    }
    if (this.aiTradingTimer) {
      clearInterval(this.aiTradingTimer);
      this.aiTradingTimer = null;
    }
  },
  updated() {
    // Re-render chart when component updates
    if (!this.isChartEmpty && this.$refs.chartCanvas) {
      this.renderChart();
    }
  }
}
</script>

<style scoped>
.compound-profit-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  text-align: right;
}

.compound-profit-copy p {
  margin: 0;
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1.55;
  text-wrap: balance;
}

.compound-profit-copy small {
  max-width: 22ch;
  font-size: 0.72rem;
  line-height: 1.65;
  opacity: 0.78;
  text-align: right;
}

</style>

